import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  public getInitialState(): any {
    return {
      core: {
        ...(window as any)._app_context,
      },
      device: null,
    };
  }
}
